import {ClienteContato} from "./cliente-contato";

export class Cliente {
  id: number;
  nome: string;
  tipoCliente: TipoPessoaEnum;
  tipoDocumentoId: number;
  documento: string;
  descricaoTipoDocumento: string;
  origemID: number;
  contatos: ClienteContato[];
}

export enum TipoPessoaEnum {
  cliente,
  outraParte,
  fornecedor,
  clienteCNPJ,
  clienteCPF
}
